import React, { forwardRef, useImperativeHandle, useState, useEffect, ImgHTMLAttributes, useCallback } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Data } from '../ContratoItemGrid';
import { Button } from '@mui/material';
import ContratoItemDataset from '../../../components/data/ContratoItemDataSet';
import styles from '../detail.module.css';

export interface HandleDialogSAPHistory {
  item: (id: string) => Promise<void>;
}
interface DialogSapHistoryProps {
}

interface DataCustom extends Data{
  criadoEm: string;
}


const DialogSapHistory: React.ForwardRefRenderFunction<HandleDialogSAPHistory, DialogSapHistoryProps> = ({}, ref) => {

  const [data, setData] = useState<DataCustom[] | null>(null);


  const handleDefineItem = useCallback(async (id: string) => {
    // const founded = rows.find(line => id === String(line.id));
    // setData(founded ? founded : null);
    try {
      const dataContratoItem = new ContratoItemDataset();
      const response = await dataContratoItem.getSAPHistoryChanges({ id });
      setData(response.data);
    } catch (err) {
      console.log(err);
      setData(null);
    }
  }, []);

  useImperativeHandle(ref, () => {
    return {
      item: handleDefineItem,
    }
  }, [handleDefineItem]);



  return (<div>
    <Dialog
      open={!!data}
      onClose={() => setData(null)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Histórico de alterações de contrato SAP
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ padding: '8px' }}>
          <ul className={styles.ulSAP}>
            {data?.map((item) => (
              <li className={styles.liSAP}>{item.contratoSap} <small className={styles.spanSAP}>{item.criadoEm.split('T')[0].split('-').reverse().join('/')}</small></li>
            ))}
            {!(data || []).length && (
              <p>Não há histórico de edições de contrato SAP para esse item.</p>
            )}
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color="error" onClick={() => setData(null)}>Fechar</Button>
      </DialogActions>
    </Dialog>
  </div>)
}

export default forwardRef(DialogSapHistory);